
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { ScannedBarcode } from 'Api/CoreApi';


//known events from table
export interface BarcodeTableEvents {
    add: ((event: Event, index: number) => {}),
    remove: ((event: Event, index: number) => {}),
    update: ((event: any, index: number, value: ScannedBarcode) =>{})
}

export interface BarcodeTableEntry{
    index: number,
    showDetails: boolean,
    value: ScannedBarcode
}


@Component({
    template: "#barcode-table-template"
})
export class BarcodeTableComponent extends ABaseComponent {
    
    @Prop()
    public events: BarcodeTableEvents;

    @Prop()
    public list: BarcodeTableEntry[];
    
    @Prop({default: false})
    public testValidation: boolean;


    @Prop({default: false})
    public tableWaiting: boolean;
    
    async created() {
   
    }


    async addBarcode(event: Event, index: number = -1){
        if(!this.events.add) return;
        await this.events.add(event, index);

        const self = this;
        Vue.nextTick(() => {
            //jump to next input field - dammit doesnt work.. :( - we need a vue.ticks.next step
            if(index > -1)
            {
                const nextElm = <HTMLInputElement[]>self.$refs['barcodenumber'+(index+1)];
                if(nextElm[0]){
                    nextElm[0].focus();
                    nextElm[0].select();
                }
              
            }
        });
    }
    
    async removeBarcode(event: Event, index: number = -1){
        if(!this.events.remove) return;
        await this.events.remove(event, index);
    }


    async update(event: any, index: number, value: ScannedBarcode){
        if(!this.events.update) return;
        await this.events.update(event, index, value);
    }

    clear(){

    }
    toggleCollapse(event: any, item: BarcodeTableEntry){
        item.showDetails = !item.showDetails;
        this.$forceUpdate();
    }
}
Vue.component('barcode-table', BarcodeTableComponent);